import React, { useState, useEffect } from 'react';
import {
  Input, Col, Row, AutoComplete,
} from 'antd';
import './style.scss';
import {
  BrowserRouter as Router, Route, withRouter, useHistory,
} from 'react-router-dom';
import { Translation } from 'react-i18next';
import FooterComponent from '../common/FooterComponent';
import { PREFIX_FRONT_URL } from '../../consts';
import FaqsMenuComponent from './ans/FaqsMenuComponent';

import Ans1 from './ans/Ans1';
import Ans2 from './ans/Ans2';
import Ans3 from './ans/Ans3';
import Ans4 from './ans/Ans4';
import Ans5 from './ans/Ans5';
import Ans6 from './ans/Ans6';

const options = (t) => ([
  {
    link: window.c.routes.FAQS_1,
    value: t('ans_title.text_1'),
  },
  {
    link: window.c.routes.FAQS_2,
    value: t('ans_title.text_2'),
  },
  {
    link: window.c.routes.FAQS_3,
    value: t('ans_title.text_3'),
  },
  {
    link: window.c.routes.FAQS_4,
    value: t('ans_title.text_4'),
  },
  {
    link: window.c.routes.FAQS_5,
    value: t('ans_title.text_5'),
  },
  {
    link: window.c.routes.FAQS_6,
    value: t('ans_title.text_6'),
  },
]);

function QuestionAnswer() {
  const history = useHistory();

  function onChange(value) {
    for (const option of options(window.$t)) {
      if (value === option.value) {
        history.push(`${PREFIX_FRONT_URL}/${option.link}`);
      }
    }
  }

  function onSearch(val) {
    console.log('search:', val);
  }

  useEffect(() => history.listen((location) => {
  }), [history]);

  return (
    <Translation>
      {(t) => (
        <div className="landing">
          <div className="landing-layout">
            <div className="faqs-banner">
              <div className="faqs-banner-content">
                {t('question_answer.title')}
              </div>
              <div className="faqs-search">
                <AutoComplete
                  options={options(t)}
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                >
                  <Input.Search size="large" placeholder={t('question_answer.placeholder')} />
                </AutoComplete>
              </div>
            </div>
            <div className="faqs-middle">
              <Row gutter={0}>
                <Col span={8} className="faqs-middle-right">
                  <FaqsMenuComponent />
                </Col>
                <Col span={16} className="faqs-middle-left">
                  <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS}`}>
                    <Ans1 />
                  </Route>
                  <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_2}`}>
                    <Ans2 />
                  </Route>
                  <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_3}`}>
                    <Ans3 />
                  </Route>
                  <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_4}`}>
                    <Ans4 />
                  </Route>
                  <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_5}`}>
                    <Ans5 />
                  </Route>
                  <Route exact path={`${PREFIX_FRONT_URL}/${window.c.routes.FAQS_6}`}>
                    <Ans6 />
                  </Route>

                </Col>
              </Row>
            </div>
            <div className="footer">
              <FooterComponent />
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default QuestionAnswer;
